// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3b40a609","977":"7778b9c5"}[chunkId] + ".chunk.js";
};